<template>
  <div class="item-base "  @click="Routersback()">
    <div class="left">
      <span>{{JoinItem.post}}</span>
      <span>杭州 | 本科 | 招30人</span>
    </div>
    <div class="right">
      <span>{{JoinItem.salary}} /月</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinContentItem",
  props:{
    JoinItem:{}
  },
  methods:{
    Routersback(){
      this.$store.commit('GetJoinData',this.JoinItem)
      this.$router.push('/join/detail')
    }
  }
}
</script>

<style lang="less" scoped>
.item-base {
  width: 66.7%;
  margin: 0 auto;
  margin-bottom:20px ;
  height: 11.1vh;
  border-left: 8px solid #188ACB;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  .left{
    span{
      display: block;
      margin-bottom: 25px;
      &:first-child{
        height: 24px;
        font-size: 24px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 36px;
      }
      &:last-child{
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }
    }
  }
  .right{
    span{
      height: 24px;
      font-size: 24px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #F98B00;
      line-height: 36px;
    }
  }
}
</style>
}